import { connect } from 'react-redux';
import actions from 'actions/InCall/InCallVideo';
import { callActions, activeCallSelectors } from '@lifesize/nucleus';
import OtherOptions from 'components/InCall/OtherOptions';
import _get from 'lodash/get';

function mapDispatchToProps(dispatch) {
  return {
    onKebabClicked: () => dispatch(actions.toggleKebabExpanded()),
    openCameraControls: () => {
      dispatch(actions.toggleCameraControls());
    },
    onDTMFClicked: number => dispatch(callActions.sendDtmf(number)),
    toggleDialPad: () => {
      dispatch(actions.toggleDialPad());
    }
  };
}

const mapStateToProps = (state) => {
  const kebabExpanded = _get(state, 'app.inCallVideo.kebabExpanded');
  const canControlFarEndCamera = activeCallSelectors.canControlFarEndCamera(state);
  return {
    kebabExpanded,
    canControlFarEndCamera
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OtherOptions);
